
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"},"content":"<path d=\"M5.391 7.34l.778 9.394h7.662l.778-9.395H5.39zm5.628-3.58A1.111 1.111 0 0010 3.09c-.456 0-.847.276-1.019.67h2.038zm-3.423 0A2.45 2.45 0 0110 1.748a2.45 2.45 0 012.404 2.014h4.263c.368 0 .666.3.666.67a.669.669 0 01-.666.672H3.333a.669.669 0 01-.666-.671c0-.371.298-.671.666-.671h4.263zm8.462 2.237l-1 12.08H4.942l-1-12.08h12.116zm-8.502 3.58v5.815h1.333V9.576H7.556zm3.555 0v5.815h1.333V9.576h-1.333z\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
